document.addEventListener('DOMContentLoaded', () => {
  syncFreeGiftWithCart();
});

hookCartApiForGiftSync();

const CART_GIFT_META_URL = '/cart?view=free-gift-meta';
const CART_GIFT_SECTION_URL = '/?sections=cart-gift-meta';
const FREE_GIFT_LINE_PROPERTY = '_free_gift';
const GIFT_SYNC_DELAY_MS = 450;

let giftSyncInProgress = false;
let giftSyncQueued = false;
let giftSyncDebounceTimer = null;
let giftSyncOwnedRequest = false;

function parseGiftVariantId(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && value > 0) return value;
  const asNumber = Number(value);
  if (!Number.isNaN(asNumber) && asNumber > 0) return asNumber;
  const gidMatch = String(value).match(/ProductVariant\/(\d+)/);
  return gidMatch ? Number(gidMatch[1]) : null;
}

function fetchCartGiftMeta() {
  return fetch(CART_GIFT_META_URL)
    .then((res) => {
      if (!res.ok) throw new Error(`Cart gift meta HTTP ${res.status}`);
      return res.text();
    })
    .then((text) => {
      const trimmed = text.trim();
      if (trimmed.startsWith('{')) {
        return JSON.parse(trimmed);
      }
      return fetch(CART_GIFT_SECTION_URL)
        .then((res) => res.json())
        .then((sections) => {
          const html = sections['cart-gift-meta'] || '';
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const el = doc.querySelector('[data-cart-gift-meta]');
          if (!el) {
            throw new Error(
              'Gift sync: deploy theme files cart.free-gift-meta.liquid and sections/cart-gift-meta.liquid'
            );
          }
          return JSON.parse(el.textContent);
        });
    });
}

function computeDesiredGifts(items) {
  const desiredByGift = new Map();
  const countedParentKeys = new Set();
  const seenParentKeys = new Set();

  items.forEach((item) => {
    if (item.is_free_gift_line) return;

    const giftId = parseGiftVariantId(item.gift_variant_id);
    if (!giftId) return;

    if (item.counts_toward_gift) {
      desiredByGift.set(giftId, (desiredByGift.get(giftId) || 0) + item.quantity);
      if (item.key) countedParentKeys.add(item.key);
      return;
    }

    if (
      item.parent_key &&
      !countedParentKeys.has(item.parent_key) &&
      !seenParentKeys.has(item.parent_key)
    ) {
      seenParentKeys.add(item.parent_key);
      const parentQty = item.parent_quantity > 0 ? item.parent_quantity : 1;
      desiredByGift.set(giftId, (desiredByGift.get(giftId) || 0) + parentQty);
    }
  });

  if (desiredByGift.size === 0 && window.__productFreeGift) {
    const { productId, giftVariantId } = window.__productFreeGift;
    items.forEach((item) => {
      if (item.is_free_gift_line || item.product_id !== productId) return;
      desiredByGift.set(
        giftVariantId,
        (desiredByGift.get(giftVariantId) || 0) + item.quantity
      );
    });
  }

  return desiredByGift;
}

function getCurrentGiftsByVariant(items, giftVariantIds) {
  const currentByGift = new Map();

  items.forEach((item) => {
    const isGift =
      item.is_free_gift_line || giftVariantIds.has(item.variant_id);

    if (!isGift) return;

    const entry = currentByGift.get(item.variant_id) || { qty: 0, keys: [] };
    entry.qty += item.quantity;
    entry.keys.push(item.key);
    currentByGift.set(item.variant_id, entry);
  });

  return currentByGift;
}

async function applyGiftSync(giftVariantId, desired, current) {
  giftSyncOwnedRequest = true;

  try {
    for (const key of current.keys) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }

    if (desired > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: giftVariantId,
            quantity: desired,
            properties: { [FREE_GIFT_LINE_PROPERTY]: 'true' }
          }]
        })
      });
    }
  } finally {
    giftSyncOwnedRequest = false;
  }
}

function collectGiftVariantIds(items, desiredByGift) {
  const giftVariantIds = new Set(desiredByGift.keys());

  items.forEach((item) => {
    const giftId = parseGiftVariantId(item.gift_variant_id);
    if (giftId) giftVariantIds.add(giftId);
    if (item.is_free_gift_line) giftVariantIds.add(item.variant_id);
  });

  return giftVariantIds;
}

function hookCartApiForGiftSync() {
  const nativeFetch = window.fetch;

  window.fetch = function cartGiftFetchWrapper(...args) {
    const response = nativeFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

    if (/\/cart\/(add|change|update)\.js/.test(url)) {
      response.then((res) => {
        if (res.ok && !giftSyncOwnedRequest) scheduleGiftSync();
      });
    }

    return response;
  };
}

function scheduleGiftSync() {
  clearTimeout(giftSyncDebounceTimer);
  giftSyncDebounceTimer = setTimeout(() => {
    syncFreeGiftWithCart();
  }, GIFT_SYNC_DELAY_MS);
}

function getCartDrawerSectionId() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return 'cart-drawer';
  const section = cartDrawer.closest('.shopify-section');
  return section ? section.id.replace('shopify-section-', '') : 'cart-drawer';
}

function getSectionInnerHTML(sectionHtml, selector) {
  const tmpl = document.createElement('template');
  tmpl.innerHTML = sectionHtml;
  const el = tmpl.content.querySelector(selector);
  return el ? el.innerHTML : '';
}

function ensureCartItemsInitialized() {
  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return null;

  const hasLineItems = Boolean(cartItems.querySelector('.cart-item'));
  cartItems.dataset.empty = hasLineItems ? 'false' : 'true';

  if (hasLineItems && !cartItems.fetchRequestOpts && typeof cartItems.init === 'function') {
    cartItems.init();
  }

  return cartItems;
}

async function updateFreeShippingNotice() {
  try {
    const cartMeta = await fetchCartGiftMeta();
    const giftVariantIds = new Set();

    cartMeta.items.forEach((item) => {
      const giftId = parseGiftVariantId(item.gift_variant_id);
      if (giftId) giftVariantIds.add(giftId);
      if (item.is_free_gift_line) giftVariantIds.add(item.variant_id);
    });

    let nonGiftQty = 0;
    cartMeta.items.forEach((item) => {
      if (!giftVariantIds.has(item.variant_id)) {
        nonGiftQty += item.quantity;
      }
    });

    const freeShippingBar = document.getElementById('free-shipping-notice');
    if (freeShippingBar) {
      freeShippingBar.style.display = nonGiftQty === 0 ? 'none' : 'block';
    }
  } catch (err) {
    console.warn('[free-gift] Could not update free shipping notice:', err);
  }
}

async function updateCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (!cartDrawer) return;

  const sectionId = getCartDrawerSectionId();
  const sectionList = [sectionId, 'cart-icon-bubble', 'free-shipping-notice'].join(',');

  try {
    const response = await fetch(`/?sections=${sectionList}`);
    const data = await response.json();

    if (!response.ok) throw new Error(`Sections HTTP ${response.status}`);

    if (typeof cartDrawer.renderContents === 'function') {
      await cartDrawer.renderContents({ sections: data }, false);
    } else {
      const drawerSections = [
        { id: 'cart-items', section: sectionId, selector: 'cart-items' },
        { id: 'cart-drawer', section: sectionId, selector: '.drawer__footer' },
        { id: 'cart-drawer', section: sectionId, selector: '.drawer__header' }
      ];

      drawerSections.forEach(({ id, section, selector }) => {
        const sectionEl = document.getElementById(id);
        if (!sectionEl || !data[section]) return;
        const target = sectionEl.querySelector(selector) || sectionEl;
        target.innerHTML = getSectionInnerHTML(data[section], selector);
      });

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data['cart-icon-bubble']) {
        const target = bubble.querySelector('.shopify-section') || bubble;
        target.innerHTML = getSectionInnerHTML(data['cart-icon-bubble'], '.shopify-section');
      }

      const notice = document.getElementById('free-shipping-notice');
      if (notice && data['free-shipping-notice']) {
        const target = notice.querySelector('.free-shipping-notice') || notice;
        target.innerHTML = getSectionInnerHTML(data['free-shipping-notice'], '.free-shipping-notice');
      }
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const drawerContent = cartDrawer.querySelector('.drawer__content');
    if (drawerContent) {
      drawerContent.classList.toggle('drawer__content--flex', cart.item_count === 0);
    }

    ensureCartItemsInitialized();
    document.querySelector('#cart-live-region-text')?.setAttribute('aria-hidden', 'false');
    await updateFreeShippingNotice();
  } catch (err) {
    console.error('[free-gift] Failed to update cart drawer:', err);
  }
}

async function syncFreeGiftWithCart() {
  if (giftSyncInProgress) {
    giftSyncQueued = true;
    return;
  }

  giftSyncInProgress = true;

  try {
    const cartMeta = await fetchCartGiftMeta();

    if (window.location.search.includes('gift_debug=1')) {
      console.log('[free-gift] cart meta:', cartMeta);
      console.log('[free-gift] desired:', Object.fromEntries(computeDesiredGifts(cartMeta.items)));
    }

    const desiredByGift = computeDesiredGifts(cartMeta.items);
    const giftVariantIds = collectGiftVariantIds(cartMeta.items, desiredByGift);
    const currentByGift = getCurrentGiftsByVariant(cartMeta.items, giftVariantIds);

    let needsUpdate = false;

    for (const giftVariantId of giftVariantIds) {
      const desired = desiredByGift.get(giftVariantId) || 0;
      const current = currentByGift.get(giftVariantId) || { qty: 0, keys: [] };

      const qtyMismatch = desired !== current.qty;
      const splitLines = current.keys.length > 1;

      if (!qtyMismatch && !splitLines) continue;

      needsUpdate = true;
      await applyGiftSync(giftVariantId, desired, current);
    }

    if (needsUpdate) {
      console.log('[free-gift] Synchronized gifts with cart');
      await updateCartDrawer();
    }
  } catch (err) {
    console.error('[free-gift] Sync error:', err);
  } finally {
    giftSyncInProgress = false;
    if (giftSyncQueued) {
      giftSyncQueued = false;
      scheduleGiftSync();
    }
  }
}
